import * as React from 'react';

import TemplateStep from 'app/pages/EmailCreateEditPage/component/TemplateStep';
import { PreviewComponent } from 'app/components/PreviewComponent/Loadable';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2';
import { Button } from '@mui/material';

export default function Step1Container({
  templateState,
  setTemplateState,
  error,
  html = true
}) {
  const [expandPreview, setExpandPreview] = React.useState(false);

  return (
    <Box sx={{ flexGrow: 1, marginTop: '90px' }}>
      <Grid
        container
        justifyContent={'center'}
        spacing={2}
        columnGap={12}
        sx={{
          minHeight: '650px',
          marginBottom: '50px',
        }}
      >
        <Grid
          md={expandPreview ? 0 : 4}
          sx={{ height: 'fit-content', display: expandPreview ? 'none' : '' }}
        >
          <TemplateStep
            templateState={templateState}
            setTemplateState={setTemplateState}
            error={error}
            html={html}
          />
        </Grid>
        <Grid md={expandPreview ? 12 : 5}>
          {html && (
            <div style={{ display: 'flex' }}>
              <Button
                variant="text"
                onClick={() => setExpandPreview(!expandPreview)}
                sx={{
                  textTransform: 'none',
                  fontSize: '16px',
                  marginRight: 'auto',
                }}
              >
                {expandPreview ? `Contract` : `Expand`}
              </Button>
            </div>
          )}
            <PreviewComponent
              compiledTemplate={templateState.html}
              showEmailContentText={false}
            />
        </Grid>
      </Grid>
    </Box>
  );
}
